/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUuNjg3NSAxMC44Njc1TDYuMzA4NzUgMTAuMjQ2MkwzLjI0NjI1IDcuMTgzNzVMMTIuMjUgNy4xODM3NUwxMi4yNSA2LjMwODc1TDMuMjQ2MjUgNi4zMDg3NUw2LjMwODc1IDMuMjQ2MjVMNS42ODc1IDIuNjI1TDEuNTY2MjUgNi43NDYyNUw1LjY4NzUgMTAuODY3NVoiIGZpbGw9ImJsYWNrIi8+PC9zdmc+";